import React from 'react';

import HomeBackground from '../../components/backgrounds/home/HomeBackground';
import Footer from '../../components/footer/Footer';
import Navbar from '../../components/navbar/Navbar';

type Props = {
  id: string;
};

const Home: React.FC<Props> = (props) => {
  return (
    <div id={props.id} data-testid={props.id}>
      <Navbar id="navbar" />
      <HomeBackground id="home-background" />
      <Footer id="footer" />
    </div>
  );
};

export default Home;
